<template>
	<div class="gallery-table-image">
		<img :src="url" loading="lazy" />
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "GalleryTableImage",
	props: {
		url: {
			type: String,
			required: true
		}
	}
});
</script>

<style lang="scss" scoped>
.gallery-table-image {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	width: 90px;
	height: 90px;
	padding: 10px;

	border-radius: 4px;
	border: 1px solid $color-black;

	cursor: pointer;
	user-select: none;

	@media (prefers-color-scheme: dark) {
		border: 1px solid $color-gray-4;
	}

	img {
		height: 100%;
		width: 100%;
		object-fit: contain;
		pointer-events: none;
	}
}
</style>
